<template>
  <div class="tags-view-container">
    <scroll-pane ref="scrollPane" class="tags-view-wrapper">
      <div
        v-for="tag in visitedViews"
        :key="tag.path"
        ref="tag"
        :data-path="tag.path"
        :class="['tags-view-item', { active: isActive(tag) }]"
        @click.middle="!isAffix(tag) ? closeSelectedTag(tag) : ''"
        @click.prevent="handleTagClick(tag)"
      >
        <span class="tag-title">{{ tag.title }}</span>
        <i
          v-if="!isAffix(tag)"
          class="el-icon-close tag-close"
          @click.prevent.stop="closeSelectedTag(tag)"
        />
      </div>
    </scroll-pane>
  </div>
</template>

<script>
import ScrollPane from './ScrollPane.vue'

export default {
  name: 'TagsView',
  components: { ScrollPane },
  computed: {
    visitedViews() {
      return this.$store.state.visitedViews
    },
    routes() {
      return this.$router.options.routes
    },
  },
  watch: {
    $route: {
      immediate: true,
      handler(route) {
        this.addTags(route)
        this.moveToCurrentTag()
      },
    },
  },
  methods: {
    isActive(route) {
      return route.path === this.$route.path
    },
    isAffix(tag) {
      return tag.meta && tag.meta.affix
    },
    addTags(route) {
      const { name } = route
      if (name && route.meta && !route.meta.hidden) {
        this.$store.dispatch('addView', route)
      }
    },
    handleTagClick(tag) {
      if (tag.path === this.$route.path) return
      this.$router.push(tag.path).catch(() => {})
    },
    closeSelectedTag(view) {
      this.$store.dispatch('delView', view).then(({ visitedViews }) => {
        if (this.isActive(view)) {
          this.toLastView(visitedViews, view)
        }
      })
    },
    toLastView(visitedViews, view) {
      const latestView = visitedViews.slice(-1)[0]
      if (latestView) {
        this.$router.push(latestView.fullPath || latestView.path).catch(() => {})
      } else {
        // 没有标签了回首页
        this.$router.push('/dashboard').catch(() => {})
      }
    },
    moveToCurrentTag() {
      const tags = this.$refs.tag
      if (!tags || !tags.length) return
      this.$nextTick(() => {
        const currentTag = tags.find(t => t.getAttribute && t.getAttribute('data-path') === this.$route.path)
        if (currentTag && this.$refs.scrollPane) {
          this.$refs.scrollPane.moveToTarget(currentTag)
        }
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.tags-view-container {
  height: 38px;
  width: 100%;
  background: #fff;
  border-bottom: 1px solid #e8e8e8;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.04);
  flex-shrink: 0;
  overflow: hidden;
}

.tags-view-wrapper {
  height: 100%;
  .tags-view-item {
    display: inline-flex;
    align-items: center;
    position: relative;
    cursor: pointer;
    height: 28px;
    line-height: 28px;
    border: 1px solid #e8e8e8;
    color: #666;
    background: #fafafa;
    padding: 0 12px;
    font-size: 13px;
    margin-left: 6px;
    margin-top: 5px;
    border-radius: 2px;
    transition: all 0.2s;
    user-select: none;

    &:first-of-type {
      margin-left: 12px;
    }

    &:hover {
      color: #2C68FF;
      border-color: #2C68FF;
    }

    &.active {
      background-color: #2C68FF;
      color: #fff;
      border-color: #2C68FF;
    }

    .tag-title {
      max-width: 140px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      display: inline-block;
    }

    .tag-close {
      margin-left: 8px;
      font-size: 12px;
      width: 14px;
      height: 14px;
      line-height: 14px;
      text-align: center;
      border-radius: 50%;
      transition: all 0.2s;

      &:hover {
        background-color: rgba(0, 0, 0, 0.12);
        color: #fff;
      }
    }
  }
}
</style>
